import { useEffect, useState } from "react";
import { Form, Formik } from "formik";
import {
  APPLY_BUTTON_STYLE,
  FILTER_SELECT_STYLES,
  RESET_BUTTON_STYLE,
} from "./reportCommon";
import { GetTransferStationsList, GetVehicleTypesList } from "./ReportApi";
import Select from "react-select";
const DEFAULT_TRIP_TO_FCTS_FILTERS = {
  fctsId: "",
  vehicleType: "",
  fromDateTime: "",
  toDateTime: "",
};

const selectPortalProps = {
  menuPortalTarget: typeof document !== "undefined" ? document.body : null,
  menuPosition: "fixed",
  styles: FILTER_SELECT_STYLES,
};

const getCurrentDateTimeLocal = () => {
  const now = new Date();
  now.setSeconds(0, 0);
  const offset = now.getTimezoneOffset();
  const localDate = new Date(now.getTime() - offset * 60000);
  return localDate.toISOString().slice(0, 16);
};

const ALL_FCTS_OPTION = { value: "", label: "All FCTS" };
const ALL_VEHICLE_TYPE_OPTION = { value: "", label: "All Vehicle Types" };

const TripToFctsFilter = ({
  initialValues = DEFAULT_TRIP_TO_FCTS_FILTERS,
  onSearch,
  onReset,
}) => {
  const [fctsOptions, setFctsOptions] = useState([ALL_FCTS_OPTION]);
  const [vehicleTypeOptions, setVehicleTypeOptions] = useState([
    ALL_VEHICLE_TYPE_OPTION,
  ]);
  const [loadingOptions, setLoadingOptions] = useState(true);

  useEffect(() => {
    const loadOptions = async () => {
      setLoadingOptions(true);
      try {
        const [fctsRes, vehicleTypeRes] = await Promise.all([
          GetTransferStationsList(),
          GetVehicleTypesList(),
        ]);

        const fctsList = fctsRes?.data?.data || [];
        const vehicleTypeList = vehicleTypeRes?.data?.data || [];

        setFctsOptions([
          ALL_FCTS_OPTION,
          ...fctsList.map((item) => ({
            value: item.transferStationId ?? item.id,
            label: item.transferStationName ?? item.name,
          })),
        ]);

        setVehicleTypeOptions([
          ALL_VEHICLE_TYPE_OPTION,
          ...vehicleTypeList.map((item) => ({
            value: item.vehicleTypeId ?? item.id,
            label: item.vehicleTypeName ?? item.name,
          })),
        ]);
      } catch (err) {
        // keep default "All" options on failure
      } finally {
        setLoadingOptions(false);
      }
    };

    loadOptions();
  }, []);

  return (
    <Formik
      initialValues={initialValues}
      enableReinitialize
      onSubmit={(values) => onSearch?.(values)}
    >
      {({ values, setFieldValue, resetForm, handleSubmit }) => (
        <Form onSubmit={handleSubmit}>
          <div className="row align-items-end">
           
            <div className="col-md-3 mb-3">
            <label className="form-label">FCTS</label>
            <Select
              options={fctsOptions}
              value={
                fctsOptions.find((option) => option.value === values.fctsId) || null
              }
              onChange={(selected) =>
                setFieldValue("fctsId", selected ? selected.value : "")
              }
              isDisabled={loadingOptions}
              isClearable
              placeholder="Search FCTS..."
              classNamePrefix="react-select"
              {...selectPortalProps}
            />
          </div>

            <div className="col-md-3 mb-3">
                <label className="form-label">Vehicle Type</label>
                <Select
                  options={vehicleTypeOptions}
                  value={
                    vehicleTypeOptions.find(
                      (option) => option.value === values.vehicleType
                    ) || null
                  }
                  onChange={(selected) =>
                    setFieldValue("vehicleType", selected ? selected.value : "")
                  }
                  isDisabled={loadingOptions}
                  isClearable
                  placeholder="Search Vehicle Type..."
                  classNamePrefix="react-select"
                  {...selectPortalProps}
                />
              </div>

            <div className="col-md-3 mb-3">
              <label className="form-label">From Date &amp; Time</label>
              <input
                type="datetime-local"
                name="fromDateTime"
                value={values.fromDateTime}
                onChange={(event) =>
                  setFieldValue("fromDateTime", event.target.value)
                }
                max={getCurrentDateTimeLocal()}
                className="form-control bg-white"
              />
            </div>

            <div className="col-md-3 mb-3">
              <label className="form-label">To Date &amp; Time</label>
              <input
                type="datetime-local"
                name="toDateTime"
                value={values.toDateTime}
                min={values.fromDateTime || undefined}
                onChange={(event) =>
                  setFieldValue("toDateTime", event.target.value)
                }
                max={getCurrentDateTimeLocal()}
                className="form-control bg-white"
              />
            </div>

            <div className="col-md-3 mb-3 d-flex gap-2">
              <button type="submit" style={APPLY_BUTTON_STYLE}>
                APPLY FILTERS
              </button>
              <button
                type="button"
                style={RESET_BUTTON_STYLE}
                onClick={() => {
                  resetForm({ values: DEFAULT_TRIP_TO_FCTS_FILTERS });
                  onReset?.();
                }}
              >
                RESET
              </button>
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default TripToFctsFilter;